import Vue from 'vue'
import RouteBreadcrumb from '@/components/molecules/RouteBreadcrumb'
import Table from '@/components/molecules/Table'
import TableHeader from '@/components/molecules/TableHeader'
import ActionDropdown from '@/components/molecules/ActionDropdown'
import EmptyState from '@/components/molecules/EmptyState'
import InputField from '@/components/molecules/InputField'
import Paging from '@/components/molecules/Paging'
import ErrorDisplay from '@/components/molecules/ErrorDisplay'
import ConfirmationButtons from '@/components/molecules/ConfirmationButtons'
import SlotSwitcher from '@/components/molecules/SlotSwitcher'
import Maps from '@/components/molecules/Maps'
import ToggleButton from '@/components/molecules/ToggleButton'
import Selector from '@/components/molecules/Selector'

[RouteBreadcrumb, Table, TableHeader, ActionDropdown, EmptyState, InputField, Paging, ErrorDisplay, ConfirmationButtons, SlotSwitcher, Maps, ToggleButton, Selector]
  .forEach(c => Vue.component(c.name, c))
